type WorldIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const WorldIcon = (props: WorldIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2299_2074)">
      <path
        d="M7.99967 1.3335C4.31967 1.3335 1.33301 4.32016 1.33301 8.00016C1.33301 11.6802 4.31967 14.6668 7.99967 14.6668C11.6797 14.6668 14.6663 11.6802 14.6663 8.00016C14.6663 4.32016 11.6797 1.3335 7.99967 1.3335ZM2.66634 8.00016C2.66634 7.5935 2.71967 7.1935 2.80634 6.8135L5.99301 10.0002V10.6668C5.99301 11.4002 6.59301 12.0002 7.32634 12.0002V13.2868C4.70634 12.9535 2.66634 10.7135 2.66634 8.00016ZM11.9263 11.6002C11.753 11.0602 11.2597 10.6668 10.6597 10.6668H9.99301V8.66683C9.99301 8.30016 9.69301 8.00016 9.32634 8.00016H5.32634V6.66683H6.65967C7.02634 6.66683 7.32634 6.36683 7.32634 6.00016V4.66683H8.65967C9.39301 4.66683 9.99301 4.06683 9.99301 3.3335V3.06016C11.9463 3.84683 13.333 5.76683 13.333 8.00016C13.333 9.38683 12.793 10.6535 11.9263 11.6002Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2299_2074">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
